import axios from '../Axios/index';

export const postWorkApi= async(data: any) => {
    return await axios.request({
        url: `api/work`,
        method: 'post',
        data: data,
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then((res: any) => {
        return res.data
    })
}

export const getAllWorkApi = async () => {
    return await axios.request({
        url: `/api/work`,
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    }).then((res: any) => {
        return res.data
    })
}

export const getAllWorkByCompanyApi = async (company_id: String) => {
    return await axios.request({
        url: `/api/work/company/${company_id}`,
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    }).then((res: any) => {
        return res.data
    })
}

export const getWorkDetailsApi = async (work_id: String) => {
    return await axios.request({
        url: `/api/work/${work_id}`,
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    }).then((res: any) => {
        return res.data
    })
}

export const updateWorkApi = async (id: String, data: any) => {

    return await axios.request({
        url: `/api/work/${id}`,
        method: 'post',
        data: data,
        headers: {'Content-Type': 'application/json'}
    }).then((res: any) => {
        return res.data
    })

}

export const patchWorkImageApi= async(work_id: any, data: any) => {
    return await axios.request({
        url: `api/image/work/${work_id}`,
        method: 'post',
        data: data,
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then((res: any) => {
        return res.data
    })
}

export const deleteWorkApi= async (work_id: any) => {
    return await axios.request({
        url: `/api/work/${work_id}`,
        method: 'delete'
    }).then((res: any) => {
        return res.data
    })

}

export const deleteWorkImageApi= async (data: any) => {
    return await axios.request({
        url: `/api/image/`,
        method: 'delete',
        data: { 'source' : data },
        headers: {'Content-Type': 'application/json'}
    }).then((res: any) => {
        return res.data
    })

}

export const deleteWorkImageApiById = async (id: any) => {
    return await axios.request({
        url: `/api/image/${id}`,
        method: 'delete',
    })
      .then((res: any) => {
        return res.data
      })   
}